type LSKey =
  | "unauthenticatedUserPrompt"
  | "noTypeAnimation"
  | "alreadyVisited"
  | "repeatedAndroidIframeLogin";

export type UserPromptLocalStorage = {
  text: string;
  timestamp: number;
};

export const ls = {
  get: (lsKey: LSKey) => {
    try {
      return JSON.parse(localStorage.getItem(lsKey) ?? "");
    } catch (_error) {
      return;
    }
  },
  set: (lsKey: LSKey, value: unknown) =>
    localStorage.setItem(lsKey, JSON.stringify(value)),
  remove: (lsKey: LSKey) => localStorage.removeItem(lsKey),
};
